import { useEffect, useState } from "react";
import { Link, useRouteMatch, useParams, useLocation } from "react-router-dom";
import Config from "../config";

function CountrySel({ fields }) {
  const [iso, setIso] = useState("");
  const [terrSub, setTerrSub] = useState("");
  const [countrySel, setCountrySel] = useState("");

  var url = window.location.pathname;
  let dateLangUrl = url.split("/")[1];
  if (
    dateLangUrl !== "fr" &&
    dateLangUrl !== "es" &&
    dateLangUrl !== "ru" &&
    dateLangUrl !== "ar" &&
    dateLangUrl !== "zh"
  ) {
    dateLangUrl = "en";
  }
  const dateLang = dateLangUrl

  useEffect(() => {
    var geoIso = "";
    var geoName = "";
    var countryIso = "" || [];
    var countryName = "" || [];
    var terrSub = "";

    const myMap = new Map([
      ["en", 0],
      ["fr", 1],
      ["es", 2],
      ["ar", 3],
      ["ru", 4],
      ["zh", 5]
    ]);

    var mapCountry = {};

    fields.forEach((field) => {
      if (field.name === "organizationCode") {
        if (field.textValues.values.length <= 1) {
          geoIso = field.textValues.values[0];
        } else {
          var geoIsoArray = [];
          field.textValues.values.forEach((g) => {
            geoIsoArray.push(g);
          });
          geoIso = geoIsoArray;
        }
      }
      if (field.name === "organizationId") {
        if (field.textValues.values.length <= 1) {
          geoName = field.textValues.values[0].split("#")[myMap.get(dateLang)];
        } else {
          var geoNameArray = [];
          field.textValues.values.forEach((g) => {
            geoNameArray.push(g ? g.split("#")[myMap.get(dateLang)] : "000");
          });
          geoName = geoNameArray;
        }
      }
      if (field.name === "countryISO3") {
        if (field.textValues.values.length <= 1) {
          countryIso = field.textValues.values[0];
        } else {
          var multiCountryIso = [];
          field.textValues.values.forEach((c) => {
            multiCountryIso.push(c ? c : "000");
          });
          countryIso = multiCountryIso;
        }
      }
      if (field.name === "country") {
        if (field.textValues.values.length <= 1) {
          countryName = field.textValues.values[0].split("#")[myMap.get(dateLang)];
        } else {
          var multiCountry = [];
          field.textValues.values.forEach((c) => {
            multiCountry.push(c ? c.split("#")[myMap.get(dateLang)] : "000");
          });
          countryName = multiCountry;
        }
      }
      if (field.name === "territorialSubdivision") {
        terrSub = field.textValues.values[0];
      }
    });

    var country = [];
    var geo = [];

    if (Array.isArray(countryName) && Array.isArray(countryIso)) {
      for (var i = 0; i < countryIso.length; i++) {
        country.push({
          countryIso: countryIso[i],
          countryName: countryName[i],
        });
      }
    }

    if (Array.isArray(geoName)) {
      for (var j = 0; j < geoName.length; j++) {
        geo.push({
          geoIso: geoIso[j],
          geoName: geoName[j],
        });
      }
    }

    if (country.length !== 0) {
      mapCountry = {
        geoIso: geoIso,
        geoName: geoName,
        country: country,
        terrSub: terrSub.split("#")[myMap.get(dateLang)],
      };
    } else {
      mapCountry = {
        geoIso: geoIso,
        geoName: geoName,
        countryIso: countryIso,
        countryName: countryName,
        terrSub: terrSub.split("#")[myMap.get(dateLang)],
      };
    }

    setCountrySel(mapCountry);
  }, [fields]);

  return (
    <div id="country">
      {countrySel.geoName ? (
        <div className="section-geo">
          <img
            alt=""
            src={`${Config.urls.flags_organization}${countrySel.geoIso.toLowerCase()
              }.gif`}
          ></img>
          <h3>{countrySel.geoName}</h3>
        </div>
      ) : null}

      {countrySel.country ? (
        <div className="d-flex justify-content-start align-items-start mt-3">
          {countrySel.country.map((c) => (
            <div className="country-wrap ms-2" key={c.countryIso}>
              <div className="section-flag">
                <img
                  alt=""
                  src={`${Config.urls.flags_country}${c.countryIso && c.countryIso.toString().toLowerCase()
                    }.svg`}
                ></img>
              </div>
              <div className="section-name">
                <Link
                  to={`/${dateLang}/country/profiles/${countrySel.countryIso}`}
                  target="_blank"
                >
                  <h3>{c.countryName}</h3>
                </Link>
                <h3 style={{ marginLeft: "10px" }}>
                  {countrySel.terrSub && countrySel.terrSub !== "National level"
                    ? `(${countrySel.terrSub})`
                    : null}
                </h3>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div>
          <div className="country-wrap">
            <div className="section-flag">
              <img
                alt=""
                src={`${Config.urls.flags_country}${countrySel.countryIso &&
                  countrySel.countryIso.toString().toLowerCase()
                  }.svg`}
              ></img>
            </div>
            <div className="section-name">
              <Link
                to={`/${dateLang}/country/profiles/${countrySel.countryIso}`}
                target="_blank"
              >
                <h3>{countrySel.countryName}</h3>
              </Link>
              {!countrySel.geoName ? (
                <h3 style={{ marginLeft: "10px" }}>
                  {countrySel.terrSub && countrySel.terrSub !== "National level"
                    ? `(${countrySel.terrSub})`
                    : null}
                </h3>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CountrySel;
